import React, { useState } from "react";

import { Card, CardContent, List, ListItem, ListItemText } from '@mui/material'
import { t } from 'i18next'
import AddAutomaticRepliesModal from '../../../components/guests/addAutomaticRepliesModal'

export const guestAutomaticRepliesText = (text) =>
	t(`guests.communicationPreferences.AutomaticReplies.${text}`)

export const AutomaticReplies = ({ data, templates, onRefresh }) => {
	const [isAddVisible, setAddVisible] = useState(false)
	const [selectedRow, setSelectedRow] = useState(null)

	return (
		<div className="w-full">
			<Card className="">
				<CardContent className="!p-0">
					<div className="flex flex-row justify-between items-center pl-4 pr-3 pt-5">
						<div className="flex flex-row items-center">
							<span className="text-black1 text-l font-medium">
								{guestAutomaticRepliesText('automaticReplies')}
							</span>
						</div>
					</div>
					<div className="flex flex-row justify-between items-center pl-4 pr-3 pt-2 pb-4">
						<div className="flex flex-row items-center">
							<span className="text-gray-500 font-medium">
								{guestAutomaticRepliesText('configureAutomatedResponses')}
							</span>
						</div>
					</div>
					<List dense={false} className="mt-4">
						{(data ? data : []).map((row, index) => (
							<ListItem
								key={index}
								onClick={() => {
									setSelectedRow(row)
									setAddVisible(true)
								}}
								className="border-b"
								secondaryAction={
									<div className="items-center cursor-pointer mr-4">
										<span className="text-[#543c7f] text-l font-medium">
											{guestAutomaticRepliesText('settings')}
										</span>
									</div>
								}
							>
								<ListItemText primary={row.title} />
							</ListItem>
						))}
					</List>
					{!data?.length && (
						<div className="mt-[10px] mb-[20px] align-middle text-gray-500">
							{guestAutomaticRepliesText('noAutomaticReplies')}
						</div>
					)}
				</CardContent>
			</Card>
			<AddAutomaticRepliesModal
				data={selectedRow}
				showModal={isAddVisible}
				templateList={templates}
				onConfirm={() => onRefresh()}
				onClose={() => {
					setSelectedRow(null)
					setAddVisible(false)
				}}
			/>
		</div>
	)
}
